import { gql } from '@apollo/client'
export const TRADE2_COUNT_RANKING = gql`
  query trade2CountRanking($type: Int!) {
    ranking: invitationBoard(type: $type) {
      value: inviteCount
      rank
      reward
      user {
        base {
          mobile
          username
        }
      }
    }
  }
`